// Messages for operator/quotes/LineItemsEditor (auto-merged by lib/i18n.ts).
export const en = {
  'operator.line_items.col.charge': 'Charge',
  'operator.line_items.col.unit': 'Unit',
  'operator.line_items.col.qty': 'Qty',
  'operator.line_items.col.cost': 'Cost',
  'operator.line_items.col.sell': 'Sell',
  'operator.line_items.col.margin': 'Margin',
  'operator.line_items.desc_aria': 'Charge {n} description',
  'operator.line_items.desc_placeholder': 'Description',
  'operator.line_items.unit_aria': 'Charge {n} unit',
  'operator.line_items.unit_placeholder': 'SET',
  'operator.line_items.qty_aria': 'Charge {n} quantity',
  'operator.line_items.cost_aria': 'Charge {n} cost (per unit)',
  'operator.line_items.sell_aria': 'Charge {n} sell (per unit)',
  'operator.line_items.remove_aria': 'Remove charge {n}',
  'operator.line_items.add': 'Add charge',
  'operator.line_items.total_cost': 'Cost',
  'operator.line_items.total_sell': 'Sell',
}

export const zhTW = {
  'operator.line_items.col.charge': '費用項目',
  'operator.line_items.col.unit': '單位',
  'operator.line_items.col.qty': '數量',
  'operator.line_items.col.cost': '成本',
  'operator.line_items.col.sell': '售價',
  'operator.line_items.col.margin': '毛利',
  'operator.line_items.desc_aria': '費用項目 {n} 說明',
  'operator.line_items.desc_placeholder': '說明',
  'operator.line_items.unit_aria': '費用項目 {n} 單位',
  'operator.line_items.unit_placeholder': 'SET',
  'operator.line_items.qty_aria': '費用項目 {n} 數量',
  'operator.line_items.cost_aria': '費用項目 {n} 成本（單價）',
  'operator.line_items.sell_aria': '費用項目 {n} 售價（單價）',
  'operator.line_items.remove_aria': '移除費用項目 {n}',
  'operator.line_items.add': '新增費用項目',
  'operator.line_items.total_cost': '成本',
  'operator.line_items.total_sell': '售價',
}
